import React from 'react';
//ProgressBar.jsx in components/common/ProgressBar.jsx
const ProgressBar = ({ current, total, label }) => {
  const percentage = (current / total) * 100;
  
  return (
    <div className="space-y-2">
      <div className="flex justify-between text-sm text-accent-white uppercase tracking-wide">
        <span>{label}</span>
        <span className="text-accent-green">{current}/{total}</span>
      </div>
      <div className="w-full h-3 bg-primary-black rounded-full overflow-hidden border-2 border-accent-green/30">
        <div 
          className="h-full bg-gradient-to-r from-accent-green to-accent-golden transition-all duration-500 ease-out relative overflow-hidden"
          style={{ width: `${percentage}%` }}
        >
          <div className="absolute inset-0 bg-white/20 animate-pulse-slow"></div>
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;